"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Disclosure = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var Shapes = _interopRequireWildcard(require("../products/shapes"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var ADDITIONAL_DISCLOSURE = 'Advertised terms are subject to change without notice. The availability of payment plans varies by providers, and not all plans may be available through your selected provider. Consult your provider for plan availability. All credit offerings are subject to credit approval.';
var getDisclosures = function getDisclosures(_ref) {
  var products = _ref.products,
    disclosureContent = _ref.disclosureContent;
  if (disclosureContent) {
    var disclosureFilter = function disclosureFilter(_ref2) {
      var type = _ref2.type;
      return products.find(function (_ref3) {
        var abbr = _ref3.abbr;
        return type === abbr;
      });
    };
    var filteredResult = disclosureContent.filter(disclosureFilter);
    return filteredResult;
  }
  return [];
};
var Disclosures = function Disclosures(_ref4) {
  var products = _ref4.products,
    className = _ref4.className,
    disclosureContent = _ref4.disclosureContent,
    isLoggedIn = _ref4.isLoggedIn;
  var additionalDisclosures = !isLoggedIn ? [{
    type: 'additional_disclosure',
    content: ADDITIONAL_DISCLOSURE
  }] : [];
  var disclosures = getDisclosures({
    products: products,
    disclosureContent: disclosureContent
  }).concat(additionalDisclosures).map(function (_ref5, index) {
    var title = _ref5.title,
      content = _ref5.content,
      type = _ref5.type,
      displayAsterisk = _ref5.displayAsterisk;
    return /*#__PURE__*/_react.default.createElement(Disclosure, {
      key: "disclosure_".concat(index),
      className: "".concat(type, "_disclosure"),
      title: title,
      content: content,
      idx: index + 1,
      displayAsterisk: displayAsterisk
    });
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('row disclosures', className)
  }, disclosures);
};
Disclosures.propTypes = {
  className: _propTypes.default.string,
  organization: _propTypes.default.string,
  products: _propTypes.default.arrayOf(Shapes.Product),
  disclosureContent: _propTypes.default.arrayOf(_propTypes.default.object),
  matchingSupscriptNumber: _propTypes.default.number,
  isLoggedIn: _propTypes.default.bool
};
Disclosures.defaultProps = {
  organization: 'Lending Club Patient Solutions',
  products: [],
  isLoggedIn: false
};
var Disclosure = function Disclosure(_ref6) {
  var idx = _ref6.idx,
    title = _ref6.title,
    content = _ref6.content,
    className = _ref6.className,
    displayAsterisk = _ref6.displayAsterisk;
  var matchingSubScript = title === 'Suggested Payment Details' ? "<sup>".concat(idx - 1, "</sup>") : '';
  var disclosureBody = content.replace('#supPlacement#', displayAsterisk ? '<strong class=\'disclosures__asterisk\'>*</strong>' : "<sup class='disclosures__sup'>".concat(idx, "</sup>")).replace('#matchSup#', matchingSubScript);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('col-xs-12', className)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "disclosures__body",
    dangerouslySetInnerHTML: {
      __html: disclosureBody
    }
  }));
};
exports.Disclosure = Disclosure;
Disclosure.propTypes = {
  idx: _propTypes.default.number,
  title: _propTypes.default.string,
  content: _propTypes.default.node,
  className: _propTypes.default.string,
  displayAsterisk: _propTypes.default.bool
};
Disclosure.defaultProps = {
  displayAsterisk: false
};
var _default = Disclosures;
exports.default = _default;
require('/var/lib/jenkins/workspace/pf-yts-ui_Release_0/node_modules/pf-payment-calculator/dist/client/components/scss/index.scss');